<!-- 由 woniu6162 创建于 2019-09-11 星期三 -->
<template>
  <div v-if="data.show" class="ponent-popup" @click="data.show = false">
    <van-picker
      @click.native.stop
      class="animated slideInUp faster"
      :show-toolbar="true"
      :default-index="data.index ? data.index - 1 : 0"
      :columns="data.list"
      @confirm="confirmPicker"
      @cancel="data.show = false"
    />
  </div>
</template>

<script>
export default {
  name: 'ponent-popup',
  mixins: [],
  components: {},
  props: {
    data: {
      type: Object,
      required: true
    }
  },

  data() {
    return {}
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {
    confirmPicker(obj) {
      this.$emit('confirm', obj)
    }
  }
}
</script>

<style lang="scss">
.ponent-popup {
  position: fixed;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  z-index: 90000;
  bottom: 0;
  left: 0;
  & > div {
    position: fixed;
    width: 100%;
    left: 0;
    bottom: 0;
  }
}
</style>
